import { render, staticRenderFns } from "./AdminChapter_show.vue?vue&type=template&id=23218082&"
import script from "./AdminChapter_show.vue?vue&type=script&lang=js&"
export * from "./AdminChapter_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports